@if (isGettingMetadata()) {
  <mat-spinner style="display: inline-block" [diameter]="15" [strokeWidth]="3"></mat-spinner>
} @else {
  <button matTooltip="Download metadata" class="item-grow"
          title="Download metadata" matButton="filled" color="secondary" (click)="downloadOrderShipmentMetadata()">
    <mat-icon>download</mat-icon>
    <span>Metadata</span>
  </button>
}
